import { render } from "./OrderForm.vue?vue&type=template&id=788d5fcc"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\danie\\OneDrive\\Documents\\AguilarTech - Projects\\OrderTaker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__